import React from "react";
import { observer } from "mobx-react";
import { SignedEditionViewStore } from "../../store";
import { SignedEditionViewForm } from "./SignedEditionViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type SignedEditionViewProps = {
  signedEditionViewStore: SignedEditionViewStore;
};

export const SignedEditionView: React.FC<SignedEditionViewProps> = observer(
  ({ signedEditionViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <SignedEditionViewForm
          signedEditionViewStore={signedEditionViewStore}
          dndaStateValue={signedEditionViewStore.dndaStateValue}
          sadaicStateValue={signedEditionViewStore.sadaicStateValue}
          publicationDate={signedEditionViewStore.publicationDateValue}
          dndaExpedienteNumber={
            signedEditionViewStore.dndaExpedienteNumberValue
          }
          dndaDocumentsVisibleColumns={
            signedEditionViewStore.dndaDocumentsVisibleColumns
          }
          dndaDocumentsSetColumnWiths={(x) =>
            signedEditionViewStore.dndaDocumentsSetColumnWiths(x)
          }
          dndaDocumentsRows={signedEditionViewStore.dndaDocumentsRowsDyn}
          ejemplarPdfFiles={signedEditionViewStore.ejemplarPdfFiles}
          dndaComprobantePdfFiles={
            signedEditionViewStore.dndaComprobantePdfFiles
          }
          blockchainCertificatesVisibleColumns={
            signedEditionViewStore.blockchainCertificatesVisibleColumns
          }
          blockchainCertificatesSetColumnWiths={(x) =>
            signedEditionViewStore.blockchainCertificatesSetColumnWiths(x)
          }
          blockchainCertificatesRows={
            signedEditionViewStore.blockchainCertificatesRowsDyn
          }
          dndaUploadLink={signedEditionViewStore.dndaUploadLinkValue}
          dndaUploadKeyReceivedAt={
            signedEditionViewStore.dndaUploadKeyReceivedAtValue
          }
          dndaUploadKeyExpiresAt={
            signedEditionViewStore.dndaUploadKeyExpiresAtValue
          }
          dndaComprobanteReceivedAt={
            signedEditionViewStore.dndaComprobanteReceivedAtValue
          }
          dndaLastComprobantePollAt={
            signedEditionViewStore.dndaLastComprobantePollAtValue
          }
          dndaLastOperationalError={
            signedEditionViewStore.dndaLastOperationalErrorValue
          }
          sadaicDeliveredAt={signedEditionViewStore.sadaicDeliveredAtValue}
          sadaicLastOperationalError={
            signedEditionViewStore.sadaicLastOperationalErrorValue
          }
          createdAt_={signedEditionViewStore.createdAt_Value}
          lastUpdatedAt_={signedEditionViewStore.lastUpdatedAt_Value}
          data_={signedEditionViewStore.data_Value}
          recordId={signedEditionViewStore.signedEditionInstance?.id || ""}
          onPrint={(handlePrint: () => void) =>
            signedEditionViewStore.printSignedEdition(handlePrint)
          }
          onCancel={() => signedEditionViewStore.cancelSignedEdition()}
          onEdit={
            signedEditionViewStore.isEditEnabled
              ? () => signedEditionViewStore.editSignedEdition()
              : undefined
          }
          ejemplarPdfViewAction={getViewAction(
            (props) =>
              signedEditionViewStore.fileDownload(props, "ejemplarPdf"),
            (props) => signedEditionViewStore.viewFilePdf(props, "ejemplarPdf")
          )}
          dndaComprobantePdfViewAction={getViewAction(
            (props) =>
              signedEditionViewStore.fileDownload(props, "dndaComprobantePdf"),
            (props) =>
              signedEditionViewStore.viewFilePdf(props, "dndaComprobantePdf")
          )}
        />
        <ErrorDialog
          open={signedEditionViewStore.errorDialogOpened}
          title={signedEditionViewStore.errorTitle}
          description={signedEditionViewStore.errorDescription}
          onClose={() => signedEditionViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={signedEditionViewStore.pdfViewerOpen}
          onClose={() => signedEditionViewStore.closePdfViewer()}
          pdfUrl={signedEditionViewStore.pdfViewerUrl}
          title={signedEditionViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
